import { connect } from 'react-redux';
import { IUser } from '../../models';
import { IRootState } from '../../redux/state';
import { bindActionCreators, Dispatch } from 'redux';
import { changeActiveAdminTab } from '../../redux/modules/route/routeCreators';
import RouteMainPage from './RouteMainPage';

function mapStateToProps(state: IRootState) {
  return {
    impersonatedUser: state.authentication.impersonatedUser,
    authentication: state.authentication as unknown as IUser,
    activeTab: state.route.activeAdminTab,
  };
}

function mapDispatchToProps(dispatch: Dispatch) {
  return {
    changeActiveTab: bindActionCreators(changeActiveAdminTab, dispatch),
  };
}

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(RouteMainPage);
